import React, { createContext, useContext, useState } from "react";

const SelectTagContext = createContext();

export const useSelectTagContext = () => useContext(SelectTagContext);

export const SelectTagProvider = ({ children }) => {
  const [formValues, setFormValues] = useState({});
  const [selectedFilters, setSelectedFilters] = useState({
    partID: "",
    productID: "",
    prediction: "",
    timestamp: "",
    factorsName: "",
    fromTimestamp: "",
    toTimestamp: "",
  });
  const [appliedFilters, setAppliedFilters] = useState({
    partID: "",
    partPrediction: "",
    partTimestamp: "",
    productID: "",
    productPrediction: "",
    productTimestamp: "",
    factorsName: "",
    fromTimestamp: "",
    toTimestamp: "",
  });
  const [minRows,setMinRows]=useState(10)
  const [cancelFilters, setCancelFilters] = useState(false);

  const value = {
    formValues,
    setFormValues,
    selectedFilters,
    setSelectedFilters,
    appliedFilters,
    setAppliedFilters,
    minRows,
    setMinRows,
    cancelFilters,
    setCancelFilters,
  };

  return (
    <SelectTagContext.Provider value={value}>
      {children}
    </SelectTagContext.Provider>
  );
};
